module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/reservation@3x-d647c4eb13aefb00b87a9426e931735f.webp";